<template>
  <div class="container">
    <div class="tabBox">
      <div
        class="tabItem"
        :class="active == 1 ? 'active' : ''"
        @click.stop="tabHandle(1)"
      >
        文章
      </div>
      <div
        class="tabItem"
        :class="active == 2 ? 'active' : ''"
        @click.stop="tabHandle(2)"
      >
        视频
      </div>
      <div
        class="tabItem"
        :class="active == 5 ? 'active' : ''"
        @click.stop="tabHandle(5)"
      >
        产品
      </div>
    </div>

    <div class="actionBox" v-if="list != null && list.length > 0">
      <div v-if="isEdit" @click.stop="allSelectHandle">全选</div>
      <div v-else></div>
      <div v-if="!isEdit" @click.stop="editHandle">编辑</div>
      <div v-else @click.stop="editHandle">完成</div>
    </div>

    <div class="contentBox" v-if="list != null && list.length > 0">
      <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getListHandle"
      >
        <van-checkbox-group v-model="result" @change="onChange">
          <div class="contentItem" v-for="(item, index) in list" :key="index">
            <div class="selectBox" v-if="isEdit">
              <van-checkbox
                shape="square"
                checked-color="#EB4E4E"
                :name="item.ContentId"
                icon-size="15px"
              ></van-checkbox>
            </div>
            <img
              class="pImg"
              :src="item.Thumbnail"
              @click="toDetail(item.HeadMemebrId, item.ContentId)"
              v-if="item.Thumbnail"
            />
            <div
              class="pNameBox"
              :class="item.Thumbnail ? '' : 'pnbWidth'"
              @click="toDetail(item.HeadMemebrId, item.ContentId)"
            >
              <div class="pName van-multi-ellipsis--l2">{{ item.Title }}</div>
              <div class="bottomBox">
                <div>
                  <van-image
                    :src="item.Photo"
                    fit="contain"
                    round
                    error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
                  />
                  <div class="companyName van-ellipsis">
                    {{ item.Headline }}
                  </div>
                </div>
                <div>
                  <div style="margin-right: 10px" v-if="active != 5">
                    {{ item.LikeNum }}赞
                  </div>
                  <div v-if="active != 5">{{ item.CommentNum }}评论</div>
                </div>
              </div>
            </div>
          </div>
        </van-checkbox-group>
      </van-list>
    </div>

    <div class="noDataBox" v-else>
      <span class="iconfont icon-kong"></span>
      <div>什么也没有！</div>
    </div>

    <div class="btnBox" v-if="isEdit && list.length > 0">
      <div class="clearbtn" @click.stop="clearAllHandle">一键清空</div>
      <div class="delectbtn" @click.stop="allDelectHandle">
        删除({{ result.length }})
      </div>
    </div>
  </div>
</template>
<script>
import { List, CheckboxGroup, Checkbox, Image } from "vant";
import {
  historyContentMemberList,
  deleteAllMemberHistory,
  batchDeleteMemberHistory,
} from "@/api/member";
export default {
  name: "history",
  components: {
    "van-checkbox-group": CheckboxGroup,
    "van-checkbox": Checkbox,
    "van-list": List,
    "van-image": Image,
  },
  data() {
    return {
      isEdit: false,
      isAll: false,

      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,
      list: [],

      active: 1,
      result: [],
    };
  },
  methods: {
    //多选框选择
    onChange(name) {
      this.result = name;
    },

    //tab切换
    tabHandle(type) {
      this.active = type;
      this.pageIndex = 1;
      this.list = [];
      this.loading = true;
      if (this.loading) {
        this.getListHandle();
      }
    },

    //编辑
    editHandle() {
      this.isEdit = !this.isEdit;
    },

    //跳转详情
    toDetail(mid, id) {
      if (this.active == 1) {
        this.$router.push({
          path: "/articleDetail",
          query: { id: id, mid: mid },
        });
      } else if (this.active == 2) {
        this.$router.push({
          path: "/videoDetail",
          query: { id: id, mid: mid },
        });
      } else {
        this.$router.push({
          path: "/productDetail",
          query: { id: id, mid: mid },
        });
      }
    },

    //全选按钮点击
    allSelectHandle() {
      var current = !this.isAll;
      var list = this.list;
      var result = [];
      // 全选
      if (current) {
        list.forEach(function (item, index) {
          result.push(item.ContentId);
        });
      }
      this.result = result;
      this.isAll = current;
    },

    //获取浏览历史
    getListHandle() {
      var that = this;
      var data = {
        ContentType: this.active,
        Page: {
          PageIndex: that.pageIndex,
          PageSize: 10,
        },
      };
      historyContentMemberList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    //一键清空
    clearAllHandle() {
      var data = { ContentType: this.active };
      deleteAllMemberHistory(data).then((res) => {
        this.pageIndex = 1;
        this.result = [];
        this.getListHandle();
      });
    },

    //多个删除
    allDelectHandle() {
      if (this.result.length > 0) {
        var data = {
          ContentType: this.active,
          Ids: this.result,
        };
        batchDeleteMemberHistory(data).then((res) => {
          this.pageIndex = 1;
          this.result = [];
          this.getListHandle();
        });
      } else {
        this.Common.showMsg("请选择要删除的选项");
      }
    },
  },
  mounted() {
    this.getListHandle();
  },
};
</script>
<style scoped src="../../../static/css/collection.css"></style>
